const baseApiUrl = process.env.REACT_APP_API_URL;
const baseJokeApiUrl = process.env.REACT_APP_JOKE_API_URL;

if (!baseApiUrl) { throw new Error('Provide REACT_APP_API_URL env'); }
if (!baseJokeApiUrl) { throw new Error('Provide REACT_APP_JOKE_API_URL env'); }

function urls() {
  return {
    root: baseApiUrl,
    LogIn: `${baseApiUrl}/api/v1/Logon/LogIn`,
    LogOut: `${baseApiUrl}/api/v1/Logon/LogOut`,
    GetAuthenticatedUser: `${baseApiUrl}/api/v1/Logon/GetAuthenticatedUser`,
    GetUserPurchasePlan: `${baseApiUrl}/api/v1/Logon/GetUserPurchasePlan`,
    Export: `${baseApiUrl}/api/v1/Export`,
    Autologin: `${baseApiUrl}/api/v1/Logon/Autologin`,

    PostInvoice: `${baseApiUrl}/api/Invoicing`,
    PutInvoice: `${baseApiUrl}/api/Invoicing`,
    GetInvoice: `${baseApiUrl}/api/Invoicing`,
    DeleteInvoice: `${baseApiUrl}/api/Invoicing`,
    DeleteInvoices: `${baseApiUrl}/api/Invoicing/DeleteDocuments`,
    GetInvoices: `${baseApiUrl}/api/Invoicing/Query`,

    GetInvoicesHeaders: `${baseApiUrl}/api/Invoicing/Headers`,
    GetInvoicesHeadersCount: `${baseApiUrl}/api/Invoicing/HeadersCount`,
    GetInvoiceBasedOnInvoice: `${baseApiUrl}/api/Invoicing/InvoiceDataBasedOnInvoice`,
    GetInvoiceSummary: `${baseApiUrl}/api/Invoicing/CalculateInvoiceSummary`,
    GetInvoiceBasedOnProforma: `${baseApiUrl}/api/Invoicing/InvoiceDataBasedOnProforma`,

    CopyInvoice: `${baseApiUrl}/api/Invoicing/Copy`,

    UpdateInvoiceLeftToPayAmount: `${baseApiUrl}/api/Invoicing/UpdateInvoiceLeftToPayAmount`,

    GetNextSequenceValue: `${baseApiUrl}/api/Sequences/NextValue`,

    // #region Products

    GetContractor: `${baseApiUrl}/api/Contractor`,
    GetContractorList: `${baseApiUrl}/api/Contractor/List`,
    DeleteContractor: `${baseApiUrl}/api/Contractor`,
    DeleteContractors: `${baseApiUrl}/api/Contractor/DeleteContractors`,
    PutContractor: `${baseApiUrl}/api/Contractor`,
    PostContractor: `${baseApiUrl}/api/Contractor`,
    AddOrUpdateContractor: `${baseApiUrl}/api/Contractor`,

    // #endregion

    // #region Contractors

    GetProduct: `${baseApiUrl}/api/Inventory`,
    GetProductList: `${baseApiUrl}/api/Inventory/List`,
    DeleteProduct: `${baseApiUrl}/api/Inventory/DeleteProduct`,
    DeleteProducts: `${baseApiUrl}/api/invemtory/DeleteProducts`,
    PutProduct: `${baseApiUrl}/api/Inventory`,
    PostProduct: `${baseApiUrl}/api/Inventory/CreateProduct`,
    AddOrUpdateProduct: `${baseApiUrl}/api/Inventory`,

    // #endregion

    GetContractorFromGus: `${baseApiUrl}/api/Contractor/gus`,
    ValidateNIP: `${baseApiUrl}/api/Contractor/nipValidation`,

    PutOrganization: `${baseApiUrl}/api/Organization`,
    GetOrganization: `${baseApiUrl}/api/Organization`,

    PutUserRating: `${baseApiUrl}/api/Users/Rating`,
    GetUserRating: `${baseApiUrl}/api/Users/Rating`,

    GetUsers: `${baseApiUrl}/api/Users`,
    PutUpdateUserPreferences: `${baseApiUrl}/api/Users/UpdateUserPreferences`,
    SendUserInvites: `${baseApiUrl}/api/Users/SendUserInvites`,
    GetInvitedUser: `${baseApiUrl}/api/Users/GetInvitedUser`,
    DeleteUser: `${baseApiUrl}/api/Users`,
    GetUserPurchasePlanLimitStates: `${baseApiUrl}/api/Users/GetUserPurchasePlanLimitStates`,

    ValidateCaptcha: `${baseApiUrl}/api/v1/Logon/ValidateCaptcha`,
    Register: `${baseApiUrl}/api/v1/Logon/Register`,
    RegisterInvitedUser: `${baseApiUrl}/api/v1/Logon/RegisterInvitedUser`,
    ConfirmRegistration: `${baseApiUrl}/api/v1/Logon/ConfirmRegistration`,
    SendResetPasswordLink: `${baseApiUrl}/api/v1/Logon/SendResetPasswordLink`,
    ResetPassword: `${baseApiUrl}/api/v1/Logon/ResetPassword`,
    ChangeUsername: `${baseApiUrl}/api/v1/Logon/ChangeUsername`,
    LoginGoogle: `${baseApiUrl}/api/v1/Logon/LoginGoogle`,
    LoginFacebook: `${baseApiUrl}/api/v1/Logon/LoginFacebook`,
    LoginLinkedIn: `${baseApiUrl}/api/v1/Logon/LoginLinkedIn`,

    // #region Costs invoices

    PostCostInvoice: `${baseApiUrl}/api/CostsInvoicing`,
    PutCostInvoice: `${baseApiUrl}/api/CostsInvoicing`,
    GetCostInvoice: `${baseApiUrl}/api/CostsInvoicing`,
    DeleteCostInvoice: `${baseApiUrl}/api/CostsInvoicing`,
    DeleteCostInvoices: `${baseApiUrl}/api/CostsInvoicing/DeleteDocuments`,
    GetCostsInvoices: `${baseApiUrl}/api/CostsInvoicing/Query`,
    GetCostsInvoicesAttachments: `${baseApiUrl}/api/CostsInvoicing/Attachments`,
    GetCostsInvoicesHeaders: `${baseApiUrl}/api/CostsInvoicing/Headers`,
    GetCostsInvoicesHeadersCount: `${baseApiUrl}/api/CostsInvoicing/HeadersCount`,
    PostCostInvoicingEmailCosts: `${baseApiUrl}/api/CostsInvoicing/EmailCosts`,

    // #endregion

    // #region Dashboard

    GetDashboard: `${baseApiUrl}/api/Dashboard`,

    // #endregion

    // #region Attachments

    AttachmentsUpload: `${baseApiUrl}/api/Attachments/Upload`,
    AttachmentDownload: `${baseApiUrl}/api/Attachments/Download`,
    AttachmentDelete: `${baseApiUrl}/api/Attachments/Delete`,
    AttachmentsDelete: `${baseApiUrl}/api/Attachments/DeleteAttachments`,
    AttachmentsSend: `${baseApiUrl}/api/Attachments/Send`,

    // #endregion

    // #region Proformas

    PostProforma: `${baseApiUrl}/api/ProformaInvoicing`,
    PutProforma: `${baseApiUrl}/api/ProformaInvoicing`,
    GetProforma: `${baseApiUrl}/api/ProformaInvoicing`,
    DeleteProforma: `${baseApiUrl}/api/ProformaInvoicing`,
    DeleteProformas: `${baseApiUrl}/api/ProformaInvoicing/DeleteDocuments`,
    GetProformas: `${baseApiUrl}/api/ProformaInvoicing/Query`,
    GetProformasHeaders: `${baseApiUrl}/api/ProformaInvoicing/Headers`,
    GetProformasHeadersCount: `${baseApiUrl}/api/ProformaInvoicing/HeadersCount`,
    GetProformaBasedOnProforma: `${baseApiUrl}/api/ProformaInvoicing/InvoiceDataBasedOnInvoice`,
    GetProformaSummary: `${baseApiUrl}/api/ProformaInvoicing/CalculateInvoiceSummary`,
    UpdateProformaLeftToPayAmount: `${baseApiUrl}/api/ProformaInvoicing/UpdateInvoiceLeftToPayAmount`,

    // #endregion

    // #region Correction invoices

    CreateCorrectionInvoice: `${baseApiUrl}/api/CorrectionInvoicing/CreateInvoice`,
    RecalculateCorrectionInvoice: `${baseApiUrl}/api/CorrectionInvoicing/RecalculateInvoice`,
    PutCorrectionInvoice: `${baseApiUrl}/api/CorrectionInvoicing/PutInvoice`,
    GetCorrectionInvoiceSummary: `${baseApiUrl}/api/CorrectionInvoicing/CalculateCorrectionInvoiceSummary`,
    GetCorrectionInvoice: `${baseApiUrl}/api/CorrectionInvoicing/GetInvoice`,
    DeleteCorrectionInvoice: `${baseApiUrl}/api/CorrectionInvoicing/DeleteInvoice`,
    DeleteCorrectionInvoices: `${baseApiUrl}/api/CorrectionInvoicing/DeleteDocuments`,
    UpdateCorrectionInvoiceLeftToPayAmount: `${baseApiUrl}/api/CorrectionInvoicing/UpdateCorrectionInvoiceLeftToPayAmount`,
    //endregion

    // #region Payments

    CalculateCartToken: `${baseApiUrl}/api/Payments/CalculateCartToken`,

    //endregion

    //region EWIBProxy

    GetBankAccountData: `${baseApiUrl}/api/EwibProxy/GetBankAccountData`,

    //endregion

    GetExportEdi: `${baseApiUrl}/api/v1/Export/Edi`,
    GetExportComarchXml: `${baseApiUrl}/api/v1/Export/ComarchXml`,
    GetOemTerms: `${baseApiUrl}/api/oem/Terms`,
    GetExportJPKFA4: `${baseApiUrl}/api/v1/Export/JPK_FA_4`,

    //region Key-Value Store

    KeyValueStoreGlobal: `${baseApiUrl}/api/KeyValueStore/Global`,
    

    //endregion

    //region JPK

    GetUSList: `${baseApiUrl}/api/JPK/GetUSList`,

    //endregion

    //region Jokes

    GetSingleJoke: `${baseJokeApiUrl}/joke/Programming?type=single`,

    //endregion
  };
}

export default urls;
